import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  GET_AZURE_METRICS_LOGS,
  GET_AZURE_METRICS_LOGS_SUCCESS,
  GET_AZURE_METRICS_LOGS_ERROR,
} from "./constant";

import { getAzureMetricsLogsApi } from "./api";

/**
 * action Type of GET_DASHBOARD_INFO
 * @param {Object} action
 */
function* getAzureMetricsLogsList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const data = yield call(getAzureMetricsLogsApi, params, undefined, provider);

    yield put({ type: GET_AZURE_METRICS_LOGS_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_AZURE_METRICS_LOGS_ERROR, error });
  }
}

/**
 * Get Login Saga
 */
export function* manageAzureMetricsLogsSaga() {
  yield takeLatest(GET_AZURE_METRICS_LOGS, getAzureMetricsLogsList);
}
